module.exports = __webpack_public_path__ + "static/media/delete-confirm.829aa740.svg";